/* eslint-disable no-underscore-dangle */
import React from 'react';
import {
  components,
} from 'react-select';

import {
  Button,
} from 'web-components';

import * as S from './styled';

const SearchOption = ({ label, innerRef, selectProps, data, ...restProps }) => (
  <components.Option {...selectProps} {...restProps}>
    <S.SearchOption ref={innerRef}>
      {label}
      {!data.__isNew__ && (
        <Button
          ghost={!restProps.isSelected}
          appearance="primary"
          spacing="compact"
          onClick={(e) => {
            e.preventDefault();
            e.stopPropagation();
            selectProps.onDuplicate(data.value);
            // I don't know how close after duplicate
            restProps.setValue();
          }}
        >
          Duplicate to this folder
        </Button>
      )}
    </S.SearchOption>
  </components.Option>
);

export default SearchOption;
